import PropTypes from 'prop-types';
import { useMediaQuery } from 'react-responsive';

import { BREAKPOINT_SIZES, BREAKPOINTS } from 'tradera-constants/breakpoints';

/**
 * Conditionally render children depending on matching breakpoint
 *
 * "is" prop has precedence over "upTo" and "downTo", which can be used together to define a range
 *
 * @param {boolean} props.desktop - LG and above
 * @param {boolean} props.tablet - MD
 * @param {boolean} props.mobile - SM and below
 * @param {string} props.is - Exact breakpoint match
 * @param {string} props.upTo - Up to (inclusive) breakpoint match
 * @param {string} props.downTo - Down to (inclusive) breakpoint match
 * @param props.children
 * @returns {children|null}
 */
const Breakpoint = props => {
    const { desktop, tablet, mobile, children } = props;
    let { is, upTo, downTo } = props;
    let mediaQuery = {};
    if (desktop || tablet || mobile) {
        if (desktop) downTo = BREAKPOINTS.LG;
        else if (tablet) is = BREAKPOINTS.MD;
        else if (mobile) upTo = BREAKPOINTS.SM;
    }
    if (is) {
        mediaQuery.minWidth = BREAKPOINT_SIZES[is].min;
        mediaQuery.maxWidth = BREAKPOINT_SIZES[is].max;
    } else {
        if (upTo) {
            mediaQuery.maxWidth = BREAKPOINT_SIZES[upTo].max;
        } else if (downTo) {
            mediaQuery.minWidth = BREAKPOINT_SIZES[downTo].min;
        }
    }
    const isActive = useMediaQuery(mediaQuery);
    return isActive ? children : null;
};
Breakpoint.propTypes = {
    desktop: PropTypes.bool,
    tablet: PropTypes.bool,
    mobile: PropTypes.bool,
    is: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
    upTo: PropTypes.oneOf(Object.keys(BREAKPOINTS)),
    downTo: PropTypes.oneOf(Object.keys(BREAKPOINTS))
};

export { Breakpoint as default, Breakpoint, BREAKPOINTS };
